/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- DISABLED GLOBAL FILTER : STYLES --------------- ++++++++++ */
export default {
    globalFilter: {
        display: 'flex',
        flexWrap: 'nowrap',
        justifyContent: 'space-between',
        color: 'gray',
        gap: pxToEm(12),
        '& .name-filters': {
            display: 'flex',
            flexWrap: 'wrap',
            alignItems: 'center',
            gap: pxToEm(12),
            '& .filter-site': {zIndex: '4',  maxWidth: '17em'},
            '& .filter-device': {zIndex: '3',  maxWidth: '15em',
                '& .divider': { margin: 0},
                '& .name-menuItems .items': {
                    height: 'auto'
                }
            },
            '& .filter-country': {zIndex: '2',  maxWidth: '17em'},
        },
        '& .datepickerdropdown': {
            filter: 'grayscale(1)',
            opacity: .4,
            pointerEvents: 'none'
        }
    },
    // wrap date dropdown when screen width small
    [`@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(885)})`]: {
        globalFilter: {
            flexWrap: 'wrap',
        }
    }
};
